document.addEventListener( 'DOMContentLoaded', () => {
	const modalPopup = document.querySelector( '#modal-popup-container' );
	const modalPopUpButton = document.querySelector( '#modal-popup-close' );

	if ( modalPopup ) {
		modalPopup.ariaHidden = 'false';

		modalPopUpButton.addEventListener( 'click', () => {
			const hidden = modalPopup.ariaHidden;
			modalPopup.ariaHidden = 'false' === hidden ? 'true' : 'false;'
		} );
	}
} );
